const getBackend = () => {
  return process.env.BACKEND_URL;
};

export default getBackend;
